import {Types} from "../../../type/Types";

export type ShoppingValueObject = {
    id: bigint
    adminId: bigint | null
    isActive: boolean
    exposedAt: Date
    catalogRank: number | null
    mid: string | null
    reviewCount: number | null
    reviewScore: number | null
    mallCount: number | null
    storeName: string | null
    productName: string | null
    productImageUrl: string | null
    productNumber: string | null
    answer: string | null
    productPrice: bigint | null
    productUrl: string | null
    mainKeywordString: string | null
    mallSequence: string | null
    categoryId: string | null
    catalogMid: string | null
    catalogProductName: string | null
    catalogLowestPrice: bigint | null
    catalogDiscountedPrice: bigint | null
    catalogDeliveryFee: bigint | null
    amount: bigint | null
    amountBeforeRefresh: bigint | null
    successCount: bigint
    failureCount: bigint
    reportCount: bigint
    createdAt: Date
    modifiedAt: Date | null
    crawlerHandledAt: Date | null
    deletedAt: Date | null
}

export namespace ShoppingValueObject {
    export function construct(o: any): ShoppingValueObject {
        return {
            id: BigInt(o.id),
            adminId: Types.asNull(o.adminId, BigInt),
            isActive: Boolean(o.isActive),
            exposedAt: new Date(o.exposedAt),
            catalogRank: Types.asNull(o.catalogRank,Number),
            mid: Types.asNull(o.mid, String),
            reviewCount: Types.asNull(o.reviewCount, Number),
            reviewScore: Types.asNull(o.reviewScore, Number),
            mallCount: Types.asNull(o.mallCount, Number),
            storeName: Types.asNull(o.storeName, String),
            productName: Types.asNull(o.productName, String),
            productImageUrl: Types.asNull(o.productImageUrl, String),
            productNumber: Types.asNull(o.productNumber, String),
            answer: Types.asNull(o.answer, String),
            productPrice: Types.asNull(o.productPrice, BigInt),
            productUrl: Types.asNull(o.productUrl, String),
            mainKeywordString: Types.asNull(o.mainKeywordString, String),
            mallSequence: Types.asNull(o.mallSequence, String),
            categoryId: Types.asNull(o.categoryId, String),
            catalogMid: Types.asNull(o.catalogMid,String),
            catalogProductName: Types.asNull(o.catalogProductName,String),
            catalogLowestPrice: Types.asNull(o.catalogLowestPrice,BigInt),
            catalogDiscountedPrice: Types.asNull(o.catalogDiscountedPrice,BigInt),
            catalogDeliveryFee: Types.asNull(o.catalogDeliveryFee,BigInt),
            amount: Types.asNull(o.amount, BigInt),
            amountBeforeRefresh: Types.asNull(o.amountBeforeRefresh, BigInt),
            successCount: BigInt(o.successCount),
            failureCount: BigInt(o.failureCount),
            reportCount: BigInt(o.reportCount),
            createdAt: new Date(o.createdAt),
            modifiedAt: Types.asNull(o.modifiedAt, o => new Date(o)),
            crawlerHandledAt: Types.asNull(o.crawlerHandledAt, o => new Date(o)),
            deletedAt: Types.asNull(o.deletedAt, o => new Date(o)),
        }
    }

    export const description: Record<keyof ShoppingValueObject, string> = {
        id: 'ID',
        adminId: '관리자 ID',
        isActive: '활성 상태',
        exposedAt: '노출 일자',
        catalogRank: '카탈로그 내 상품 순위',
        mid: '상품 미드값',
        reviewCount: '리뷰수',
        reviewScore: '별점',
        mallCount: '판매처수',
        storeName: '스토어 명',
        productName: '상품 명',
        productImageUrl: '상품 이미지 URL',
        productNumber: '상품 번호',
        answer: '미션 정답',
        productPrice: '상품 가격',
        productUrl: '상품 URL',
        mainKeywordString: '키워드',
        mallSequence: '몰 시퀀스',
        categoryId: '카테고리 ID',
        catalogMid: '카탈로그 mid',
        catalogProductName: '카탈로그 상품명',
        catalogLowestPrice: '카탈로그 상품 최저가',
        catalogDiscountedPrice: '카탈로그 상품 할인가',
        catalogDeliveryFee: '카탈로그 상품 배송비',
        amount: '상품 수량',
        amountBeforeRefresh:'부활 전 수량',
        successCount: '성공',
        failureCount: '실패',
        reportCount: '신고',
        createdAt: '생성 시각',
        modifiedAt: '수정 시각',
        crawlerHandledAt: '크롤러 응답 데이터 마지막 핸들 일자',
        deletedAt: '삭제 시각',

    }
}